<template>
	<div>
        <span v-if="value === 0">
            {{ placeholder }}
        </span>
        <span v-else>
            {{ date }}
        </span>
    </div>
</template>
<script>
    import { dateFormatter } from '../../filters/vue_filters';
    export default {
        props : {
            value: {
                type     : Number,
                required : true,
                default  : 0
            },
            placeholder : {
                default : '',
                required: false
            },
        },
        computed: {
            date() {
                if (isNaN(this.value)) { return ''; }
                return dateFormatter(this.value, 'SLASHED_DATE')
            }
        } 
    }
</script>